module.exports = __webpack_public_path__ + "img/add-circle.c80e9aca.svg";